import type { TranslationMessages } from '../types';

export const grab: TranslationMessages = {
  mappings: {
    title: 'Product Mappings',
    delete_confirm: 'Are you sure you want to delete this mapping?',
  },
  settings: {
    title: 'Grab Integration Settings',
  },
  sync: {
    title: 'Menu Sync Dashboard',
  },
  };
